import { Reducer } from 'redux';
import { Actions } from '../actions/Actions';
import { MaaSCreationData } from 'src/Models/UpdateWorkitem';

// TODO: old state should be replacted with AuthenticationStatusState and action should be replaced with AuthenticationAction 
export const maaSreducer: Reducer<MaaSCreationData> =
    (oldState: MaaSCreationData = initialMaaSState, action: any): MaaSCreationData => {
        let newState: MaaSCreationData;
        switch (action.type) {
            case Actions.GET_MAAS_CREATION_DATA:
                newState = { ...oldState };
                break;
            case Actions.SAVE_MAAS_CREATION_DATA:
                newState = action.payload;
                break;
            default:
                newState = oldState;
                break;
        }
        return newState;
    };

export const initialMaaSState: MaaSCreationData = {
    requestType: "",
    intrestedAccountProfiling: false,
    intrestedOrgChart: false,
    requesterAssignedTo: "",
    requesterUniqueName: "",
    role: "",
    marketerSpecificRole: "",
    sellerSpecificRole: "",
    industry: "",
    segment: "",
    ou: "",
    MCEMStage: "",
    comments: "",
    tpid: "",
    CRMId: "",
    Account: "",
    ChildAccount: "",
    OpportunityId: "",
    Url: "",
    spName: "",
    spTitle: "",
    accSelection: "",
    spCountry: "",
    addExisting: "",
    replaceExisting: false,
    itemsList: [],
    BDMsList: [],
    AOI: "",
    documentDate: "",
    documentLink: "",
    bdmList: [],
    multipleTPID: "",
    eventName: "",
    eventDate: "",
    eventType: "",
    eventRegistrationURL: "",
    solutionAreaSalesPlay: "",
    sMPPApprovalID: "",
    dataCaptureDate: "",
    leadSourceType: "",
    eventContactListpassword: "",
}

export const getMaaSData = (dispatch: any) => {
    dispatch({
        type: Actions.GET_MAAS_CREATION_DATA
    });
};

export const setMaaSData = (payload: MaaSCreationData) => (dispatch: any) => {
    dispatch({
        type: Actions.SAVE_MAAS_CREATION_DATA,
        payload
    });
};

